import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home/index.vue";
import Login from "@/views/Login/index.vue";
import NoticeDetail from "@/views/NoticeDetail/index.vue";
import Test from "@/views/Test/index.vue";
import { useI18n } from 'vue-i18n';
import i18n from '../locales';
import _service from "@/service";
import { showToast } from "vant";
import { iframePost } from "@/utils";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: { keepAlive: true},
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { keepAlive: true},
    },
    {
      path: "/notice-detail/:id",
      name: "NoticeDetail",
      component: NoticeDetail,
      meta: { keepAlive: true},
    },
    {
      path: "/test",
      name: "Test",
      component: Test,
      meta: { keepAlive: true},
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
      // return { top: 0 };
    } else {
      return { top: 0 };
    }
  },
});


// 全局前置守卫
router.beforeEach(async(to, from, next) => {
  //重置页面有弹窗不让滚动的特性 防止如果有页面跳走之前忘记关闭弹窗
  document.body.style.overflow = "inherit"

  // 生产环境从链接进去带token
  if (to.query.token) {
    sessionStorage.setItem('APLINK_STARNEST_TOKEN',`${to.query.token}`)
  }
  // if (!sessionStorage.getItem('APLINK_STARNEST_TOKEN')) {
  //   iframePost('needlogin')
  // }
  // 根据iframe传的语言更改语言
  if (to.query.locale) {
    localStorage.setItem('starnest-locale',`${to.query.locale}`)
    i18n.global.locale.value = to.query.locale as string
  }
  if (to.query.currency) {
    sessionStorage.setItem('currency',`${to.query.currency}`)
  }
  if (to.query.account) {
    sessionStorage.setItem('STARNEST_ACCOUNT',`${to.query.account}`)
  }
  if (to.query.ORDER_DATA) {
    sessionStorage.setItem('ORDER_DATA',`${to.query.ORDER_DATA}`)
  }
  if (to.query.parentUrl) {
    sessionStorage.setItem('PARENT_URL',`${to.query.parentUrl}`)
  }

  // 支付完回跳带参处理
  if (to.path === '/payment' && to.query.resultCode) {
    if (to.query.resultCode === '0000') {
      next('/pay-success')
    }else{
      next('/pay-fail')
    }
  }
  if (to.path === '/payment' && to.query.trade_status) {
    if (to.query.trade_status === 'TRADE_FINISHED') {
      next('/pay-success')
    }else{
      next('/pay-fail')
    }
  }
  
  // 根据路由信息修改title
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }else{
    document.title = "\u200b"
  }
  next();
});


export default router;
